import {
	ApiClient,
	IAnonymousSocialMediaPost,
	IOperationResult,
	IOperationResultNoValue,
	ISocialMediaPost,
} from './Api';

export type ServiceConstructor = new (client: ApiClient) => IService;

export interface IService {
	getBasePath(): string;
	getByToken(id: string, token: string): Promise<[IOperationResult<ISocialMediaPost>, IOperationResultNoValue]>;
}

export class SocialMediaService implements IService {
	protected mClient: ApiClient;

	constructor(client: ApiClient) {
		this.mClient = client;
	}

	public getBasePath() {
		return 'social/post';
	}

	public getByToken = (id: string, token: string) => {
		return this.mClient.get<IAnonymousSocialMediaPost>(`${this.getBasePath()}/${id}/anonymous?token=${token}`);
	};
	public getLogoByToken = (id: string, token: string) => {
		return this.mClient.get<string>(`${this.getBasePath()}/${id}/anonymous/logo?token=${token}`);
	};
	public getWhiteBackgroundByToken = (id: string, token: string) => {
		return this.mClient.get<boolean>(`${this.getBasePath()}/${id}/anonymous/hideWhiteBackground?token=${token}`);
	};
}
